const Config = {
  API_URL: (window as any).API_URL || 'http://localhost:3000',
  GA_ID: (window as any).GA_ID || 'UA-213693335-1',
  development: process.env.NODE_ENV === 'development',
  env: process.env
};

export default Config;
